import { useEffect, useState } from 'react'
import { useInfiniteQuery } from 'react-query'
import { getMonyPoolsDetailUsers } from 'services/fund'

export default function useGetUsers(id: string | undefined, search?: string) {
    const [poolShipId, setPoolShipId] = useState<number | undefined>()
    const [numberOfShares, setNumberOfShares] = useState<number | undefined>(
        undefined
    )
    const profileStringify = localStorage.getItem('profile')
    const profile = profileStringify && JSON.parse(profileStringify)
    const { data, isLoading, fetchNextPage, refetch } = useInfiniteQuery(
        ['money-pools-detail-users-in-funds', search],
        ({ pageParam = 1, queryKey }) =>
            getMonyPoolsDetailUsers(pageParam, id, search),
        {
            getNextPageParam: (lastPage, allPages) => {
                const lastRecord = allPages[allPages.length - 1]?.next || ''
                return lastRecord
                    ? new URL(lastRecord).searchParams.get('cursor')
                    : undefined
            },
        }
    )
    useEffect(() => {
        if (data && profile) {
            const findPoolShip = data.pages
                .flatMap((x) => x.results)
                .find((item) => item?.member?.id === profile?.id)
            setNumberOfShares(findPoolShip?.number_of_shares)
            setPoolShipId(findPoolShip?.id)
        }
    }, [data])
    return {
        data,
        isLoading,
        poolShipId,
        fetchNextPage,
        numberOfShares,
        refetch,
    }
}
